export default __webpack_public_path__ + "static/media/fpay.11484269.svg";